import { useState } from 'react';

type Options = {
  data: any[]
  /**
   * 默认显示长度
   */
  size?: number
  /**
   * 每次增加的数量
   */
  setupNum?: number
}

const useLoadMore = (options: Options) => {
  const { data, size = 4, setupNum = 2 } = options

  const [sizes, useSize] = useState(size)

  const loadMore = () => {
    useSize(sizes + setupNum)
  }

  const reset = () => {
    useSize(size)
  }

  const goTo = (size: number) => {
    useSize(size)
  }

  const toLast = () => {
    useSize(data.length)
  }

  const loadLess = () => {
    useSize(sizes - setupNum)
  }

  const copyData = data.slice(0, sizes)

  const isNoMore = copyData.length === data.length

  const isNoLess = copyData.length <= size

  return { data: copyData, goTo, sizes, isNoMore, isNoLess, loadMore, loadLess }
}

export default useLoadMore
